import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    TextField
} from '@mui/material';  
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import { InputPhoneMask } from '../../components/input-numbers'


const OrdereePage = ({ order }) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm()

    useEffect(() => {
        const defaultValues = {
            order_r_name: order?.order_r_name || '',
            order_r_hp: order?.order_r_hp || '',
            order_r_email: order?.order_r_email || '',
            order_r_tel: order?.order_r_tel || '',
            zip: order?.order_r_zip1 + order?.order_r_zip2 || '',
            order_r_addr1: order?.order_r_addr1 || '',
            order_r_addr2: order?.order_r_addr2 || '',
        }
        reset(defaultValues)

    }, [reset, order]);


    const onSubmit = async (data, e) => {
        const params = JSON.stringify({
            "order_r_name": data.order_r_name,
            "order_r_hp": data.order_r_hp,
            "order_r_email": data.order_r_email,
            "order_r_tel": data.order_r_tel,
            "order_r_zip1": data.zip.slice(0, 3),
            "order_r_zip2": data.zip.slice(3, 5),
            "order_r_addr1": data.order_r_addr1,
            "order_r_addr2": data.order_r_addr2
        });

        try {
            await apiService.put(`/orders/ordee/${order.orderid}`, params);
            toast.success('업데이트 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Card>
            <CardHeader title='수취인 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="ordereeform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_name'
                                    control={control}
                                    defaultValue=''
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='수신자'
                                            id='order_r_name'
                                            onChange={onChange}
                                            placeholder='수신자을 입력해주세요'
                                            error={Boolean(errors.order_r_name)}
                                            aria-describedby='validation-async-order_r_name'
                                        />
                                    )}
                                />
                                {errors.order_r_name && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_r_name'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="order_r_hp">연락처(휴대폰)</InputLabel>
                                <Controller
                                    name='order_r_hp'
                                    control={control}
                                    defaultValue=''
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <InputPhoneMask
                                            mask="000-0000-0000"
                                            value={value}
                                            label='연락처(휴대폰)'
                                            id='order_r_hp'
                                            onChange={onChange}
                                            placeholder='휴대폰 번호를 입력해주세요'
                                            error={Boolean(errors.order_r_hp)}
                                            aria-describedby='validation-async-order_r_hp'
                                        />
                                    )}
                                />
                                {errors.order_r_hp && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_r_hp'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_tel'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='연락처'
                                            id='order_r_tel'
                                            onChange={onChange}
                                            placeholder='연락처를 입력해주세요'
                                            error={Boolean(errors.order_r_tel)}
                                            aria-describedby='validation-async-order_r_tel'
                                        />
                                    )}
                                />
                                {errors.order_r_tel && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_r_tel'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <Controller
                                    name='zip'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='우편번호'
                                            id='zip'
                                            inputProps={{ minLength: 5, maxLength: 5 }}
                                            onChange={onChange}
                                            placeholder='우편번호를 입력해주세요'
                                            error={Boolean(errors.zip)}
                                            aria-describedby='validation-async-zip'
                                        />
                                    )}
                                />
                                {errors.zip && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-zip'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={9}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_addr1'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='주소'
                                            id='order_r_addr1'
                                            onChange={onChange}
                                            placeholder='주소를 입력해주세요'
                                            error={Boolean(errors.order_r_addr1)}
                                            aria-describedby='validation-async-order_r_addr1'
                                        />
                                    )}
                                />
                                {errors.order_r_addr1 && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_r_addr1'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_addr2'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='세부주소'
                                            id='order_r_addr2'
                                            onChange={onChange}
                                            placeholder='세부 주소를 입력해주세요'
                                            error={Boolean(errors.order_r_addr2)}
                                            aria-describedby='validation-async-order_r_addr2'
                                        />
                                    )}
                                />
                                {errors.order_r_addr2 && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_r_addr2'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="ordereeform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default OrdereePage
